import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch } from './index';

type InitialStateType = {
    loading: boolean;
    value: number;
};

const initialState: InitialStateType = {
    loading: true,
    value: 0,
};

const forceSignOutSlice = createSlice({
    name: 'forceSignOut',
    initialState,
    reducers: {
        setLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },
        setForceSignOutValue(state, action: PayloadAction<number>) {
            state.value = action.payload;
        },
    },
});

export function getForceSignOutValue() {
    return async (dispatch: AppDispatch) => {
        try {
            dispatch(forceSignOutSlice.actions.setLoading(true));

            if (true) {
                dispatch(forceSignOutSlice.actions.setForceSignOutValue(Math.random()));
            }
        } catch (err) {
        } finally {
            dispatch(forceSignOutSlice.actions.setLoading(false));
        }
    };
}

export default forceSignOutSlice.reducer;
export const { setLoading } = forceSignOutSlice.actions;
